import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = ["Flights", "Insurance", "Tours", "Visas", "Umrah", "Services", "About"];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 bg-[#FFE000] transition-shadow ${scrolled ? "shadow-md" : "shadow-sm"}`}>
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-[75px]">
          {/* Logo */}
          <a href="/" className="flex-shrink-0">
            <img
              src="https://storage.readdy-site.link/project_files/6f8e2f56-80e7-4d90-9ea4-7823017b65ac/8001b0b9-8322-4e8e-a8ae-9e1b8da726a7_Untitled-design-13-2.png?v=4559551c5eed3b8ee3339af394cf2f6c"
              alt="flightfare.pk"
              className="h-[75px] w-auto object-contain"
            />
          </a>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-0">
            {navLinks.map((item, idx, arr) => (
              <span key={item} className="flex items-center">
                <a
                  href={item === "Flights" ? "/" : item === "About" ? "/about" : `/${item.toLowerCase()}`}
                  className="text-gray-800 text-sm font-medium hover:text-gray-900 transition-colors px-3 py-2 whitespace-nowrap cursor-pointer"
                >
                  {item}
                </a>
                {idx < arr.length - 1 && (
                  <span className="text-[#FFE000] text-sm select-none">|</span>
                )}
              </span>
            ))}
          </div>

          {/* Desktop Right Side */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+923711432451"
              className="flex items-center gap-2 text-gray-800 text-sm font-medium whitespace-nowrap cursor-pointer hover:text-gray-900 transition-colors"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <img
                  src="https://quickflytravel.com/images/phone-circle.png"
                  alt="Phone"
                  className="w-5 h-5 object-contain"
                />
              </div>
              03711432451
            </a>
            <a
              href="/contact"
              className="border border-gray-800 text-gray-800 text-sm font-semibold px-4 py-1.5 rounded hover:bg-gray-800 hover:text-[#FFE000] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </a>
          </div>

          {/* Mobile: Phone + Hamburger */}
          <div className="flex md:hidden items-center gap-3">
            <a href="tel:+923711432451" className="text-gray-800 cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-fill text-xl text-gray-800"></i>
              </div>
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              className="w-8 h-8 flex items-center justify-center text-gray-800 cursor-pointer"
            >
              <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-lg px-4 py-4 flex flex-col gap-1">
            {navLinks.map(item => (
              <a
                key={item}
                href={item === "Flights" ? "/" : item === "About" ? "/about" : `/${item.toLowerCase()}`}
                onClick={() => setMenuOpen(false)}
                className="text-gray-800 text-sm font-medium py-2.5 border-b border-gray-100 last:border-0 hover:text-gray-900 transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
            <a
              href="tel:+923711432451"
              className="flex items-center gap-2 text-gray-800 text-sm font-medium py-2.5 border-b border-gray-100 cursor-pointer"
            >
              <i className="ri-phone-fill text-gray-800"></i>
              03711432451
            </a>
            <a
              href="/contact"
              className="mt-1 text-center border border-gray-800 text-gray-800 text-sm font-semibold px-4 py-2 rounded hover:bg-gray-800 hover:text-[#FFE000] transition-colors cursor-pointer"
            >
              Contact Us
            </a>
          </div>
        )}
      </nav>
    </>
  );
}
